<template>
  <footer class="app-footer">
    <!-- Left: user status -->
    <div class="footer-left">
      <span class="footer-dot"></span>
      <span class="footer-user">
        <i class="fontello-icon" style="font-size:0.85rem; opacity:0.6">&#xf2be;</i>
        {{ $store.getters.getUser.name }}
      </span>
    </div>

    <!-- Right: brand + current store -->
    <div class="footer-right" v-if="stateStores.current.brandName">
      <span class="footer-brand">{{ stateStores.current.brandName }}</span>
      <span class="footer-sep">&rsaquo;</span>
      <span class="footer-store" v-if="stateStores.current.storeName">{{ stateStores.current.allStores ? $tr(stateStores.current.storeName) : stateStores.current.storeName }}</span>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FooterWrapper",
  computed: {
    ...mapState({
      stateStores: "stores",
      stateCommon: "common",
    }),
  },
};
</script>

<style lang="css" scoped>
.app-footer {
  position: fixed;
  right: var(--drawer-width, 0px);
  bottom: 0;
  left: var(--sidebar-width, 260px);
  transition: left var(--motion-base) var(--ease-out), right var(--motion-base) var(--ease-out);
  z-index: 15;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  background: var(--bg-primary);
  backdrop-filter: blur(8px);
  border-top: 1px solid var(--border-primary);
  font-size: 0.75rem;
}

/* Left - user */
.footer-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-secondary);
}
.footer-dot {
  width: 6px;
  height: 6px;
  background: var(--status-success);
  border-radius: 50%;
  /* A still dot: no pulse (owner, 2026-09-21: no motion in Connect). */
  box-shadow: 0 0 0 3px var(--success-bg);
}
.footer-user {
  font-weight: 500;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

/* Right - brand + store label */
.footer-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-brand {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--brand-orange, #f97316);
  white-space: nowrap;
}

.footer-sep {
  color: var(--text-muted);
  font-size: 0.8rem;
  line-height: 1;
}

.footer-store {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}
</style>
